export const paths = {
  app: {
    path: "/",
    getHref: () => "/",
  },
  beautyProfiler: {
    path: "/beauty-profiler",
    getHref: () => "/beauty-profiler",
    profiler: {
      path: "/beauty-profiler/profiler",
      getHref: () => "/beauty-profiler/profiler",
    },
  },
  looksGallery: {
    path: "/looks-gallery",
    getHref: () => "/looks-gallery",
    beautyServices: {
      path: "/looks-gallery/beauty-services",
      getHref: () => "/looks-gallery/beauty-services",
    },
    looksGallery: {
      path: "/looks-gallery/looks-gallery",
      getHref: () => "/looks-gallery/looks-gallery",
    },
  },
  fragranceProfiler: {
    path: "/fragrance-profiler",
    getHref: () => "/fragrance-profiler",
    profiler: {
      path: "/fragrance-profiler/profiler",
      getHref: () => "/fragrance-profiler/profiler",
    },
  },
};
